export default __webpack_public_path__ + "81e8ffdc04f3f8b13236e90cec6234fd.png";